import { useState } from 'react';
import PropTypes from 'prop-types';

import { Button, ConnectionStatusLabel } from 'ui';
import { CONNECTION_STATUS } from 'common/constants';

import IntegrationCard from './IntegrationCard';
import ConnectDtdModal from './ConnectDtdModal';

const DoubleTheDonationCard = ({ integrations, onConnect, onDisconnect }) => {
  const [modalOpen, setModalOpen] = useState(false);
  const [disconnecting, setDisconnecting] = useState(false);
  const connected = !!integrations.length;

  const handleDisconnect = async () => {
    setDisconnecting(true);
    try {
      await onDisconnect(integrations[0].integrationId);
    } finally {
      setDisconnecting(false);
    }
  };

  return (
    <IntegrationCard>
      <div className="flex items-center justify-between space-x-6">
        <div className="flex items-center space-x-6">
          <img
            src="/integrations/double-the-donation-logo.webp"
            className="m-auto h-auto w-[140px]"
            alt="Double the Donation Logo"
          />

          <div className="space-y-2">
            <div className="flex items-center space-x-2">
              <h3 className="text-h5 font-semibold">Double the Donation</h3>

              <ConnectionStatusLabel
                status={connected ? CONNECTION_STATUS.connected : CONNECTION_STATUS.notConnected}
              />
            </div>

            {connected ? (
              <p className="text-base">
                Your Double the Donation account is connected. Matching gift search is available on donation pages where
                it has been enabled.
              </p>
            ) : (
              <p className="max-w-96 text-base">
                Double the Donation Matching helps nonprofits increase their donations through corporate matching gift
                programs.{' '}
                <a
                  href="https://forms.zohopublic.com/impactventures/form/LetDonorSpringConnectYouWithDoubletheDonation/formperma/uWSSGmm8dDPRRtrIzjW52NsNUgDYazJgdLR3ZVfPkH4"
                  target="_blank"
                  rel="noreferrer"
                  className="text-primary-700 underline"
                >
                  Learn more about Double the Donation
                </a>
              </p>
            )}
          </div>
        </div>

        {connected ? (
          <Button title="Disconnect" color="primary" onClick={handleDisconnect} loading={disconnecting} />
        ) : (
          <Button title="Connect" color="primary" onClick={() => setModalOpen(true)} />
        )}
      </div>

      <ConnectDtdModal open={modalOpen} onClose={() => setModalOpen(false)} onConnect={onConnect} />
    </IntegrationCard>
  );
};

DoubleTheDonationCard.defaultProps = {
  integrations: [],
};

DoubleTheDonationCard.propTypes = {
  integrations: PropTypes.arrayOf(PropTypes.object),
  onConnect: PropTypes.func.isRequired,
  onDisconnect: PropTypes.func.isRequired,
};

export default DoubleTheDonationCard;
